/* 签到弹窗组件 */
<template>
  <transition name="fade">
    <div class="sign-in-popup" v-if="!!type">
      <div class="popup-box-container">
        <div class="popup-box">
          <img
            :class="[
            'icon',
            {
              guide: type === 'guide' || type === 'success' || type === 'fail'
            }]"
            :src="icon"
            alt
          />
          <p v-html="text" :class="{'notguide': type === 'success' || type === 'fail'}"></p>
        </div>
        <slot>
          <img class="close-icon" :src="closeIcon" alt @click="close" />
        </slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    type: {
      type: String
    },
    icon: {
      type: String
    },
    text: {
      type: String
    },
    close: {
      type: Function
    }
  },
  data() {
    return {
      signInImg: {
        guide: {
          icon: require('@/assets/images/pop_img_guide.png'),
          text: '请手动打开定位<br>设置-南方Plus-开启定位'
        },
        success: {
          icon: require('@/assets/images/pop_img_location_success.png'),
          text: '定位签到成功'
        },
        fail: {
          icon: require('@/assets/images/pop_img_location_fail.png'),
          text: '定位签到失败'
        }
      },
      closeIcon: require('@/assets/images/adv_pop_icon_close.png')
    }
  },
  watch: {
    type(val) {
      if (!val) return
      const set = this.signInImg[this.type]
      !this.icon && (this.icon = set.icon)
      !this.text && (this.text = set.text)
    }
  }
}
</script>

<style lang="scss" scoped>
.sign-in-popup {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  transition: transform all 0.3s;
  .popup-box-container {
    width: 6rem;
    min-height: 4rem;
    position: absolute;
    left: 50%;
    top: calc(50% - 0.3rem);
    transform: translate(-50%, -50%);
    text-align: center;
  }
  .close-icon {
    width: 0.68rem;
    margin-top: 0.4rem;
  }
  .popup-box {
    width: 6rem;
    min-height: 3.24rem;
    background: #ffffff;
    border-radius: 0.2rem;
    padding: 0.4rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    > img {
      width: 1.5rem;
    }
    .guide {
      width: 2.4rem;
    }
    > p {
      width: 3.35rem;
      font-size: 0.3rem;
      color: #333333;
      text-align: center;
      display: inline-block;
      line-height: 0.44rem;
      margin-top: 0.2rem;
      &.notguide {
        margin-top: 0.3rem;
      }
    }
  }
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease-in-out 0.2s;
}
.fade-enter-to,
.fade-leave {
  opacity: 1;
}
</style>